import axios from "axios";
import { clinicFromPath, logoutToLogin } from "../app/services/session";

const MainApi = axios.create({
	baseURL: process.env.REACT_APP_API_ENDPOINT,
	// baseURL: `http://localhost:8080/`,
	// baseURL: `http://103.46.239.141:2000/`,
	// baseURL: `https://api.heartbeat.design/`,
});

// pages a signed-out user may be on; a 401 there is a normal answer, not an ended session
const PUBLIC_CLINIC_PAGE = /^\/clinic\/[^/]+\/?(login|sign-up|forgotpassword|forgotPin|resetpassword|resetpin)?\/?$/i;
let loggingOut = false;

/*
 * The backend answers 401 only when the JWT is missing, expired or revoked (forced logout,
 * deactivated user); a role without access gets 403. So a 401 on a clinic page for a request that
 * carried a token means the session is over: sign out and go to the login page, once, instead of
 * leaving every screen failing.
 */
MainApi.interceptors.response.use(undefined, (error) => {
	const sentToken = !!error?.config?.headers?.Authorization;
	if (
		error?.response?.status === 401 &&
		sentToken &&
		!loggingOut &&
		localStorage.getItem("token") &&
		clinicFromPath() &&
		!PUBLIC_CLINIC_PAGE.test(window.location.pathname)
	) {
		loggingOut = true;
		logoutToLogin(clinicFromPath(), "Your session has expired. Please sign in again.");
	}
	return Promise.reject(error);
});

export default MainApi;
